import React, { Component } from "react";
import styles from "./Dashboard.local.scss";
import { LayoutFactory } from "./Layouts/LayoutFactory";
import { ModeContext } from "./../Layout/Theme";
import classnames from "classnames";
import { connect } from "react-redux";
import { getLabelsByLng } from "../../utils";

class Slide extends Component {
  static contextType = ModeContext;

  render() {
    const {
      embeddedStyle,
      slide: { labels, layout, id },
      isResponsive,
      comments,
      handleSlideListOnClick,
      isComposition,
      isPresentation,
      isPreparePresentation,
      explanations,
      indicators,
      lng,
      dashboardPage,
      extraInfos,
      currentOrganization,
      inSlideView
    } = this.props;
    const {
      config: { background, componentsBackground }
    } = layout;
    let logo =
      currentOrganization && currentOrganization.avatarUrl
        ? currentOrganization.avatarUrl
        : null;
    let logoBlock = (
      <span
        className={classnames("boxes__box__logo", styles.deg_logo)}
        style={{ backgroundImage: `url(${logo})` }}
      />
    );

    return (
      <div
        className={
          this.context === "embedded" || embeddedStyle
            ? styles.slide_embedded
            : styles.slide
        }
        style={{
          marginBottom: dashboardPage ? "30px" : "",
          background: !embeddedStyle
            ? background
              ? background
              : "#FFFFFF"
            : "#FFFFFF",
          backgroundSize: "100% auto",
          backgroundPosition: "center",
          maxHeight:
            this.context === "embedded" || embeddedStyle
              ? "fit-content"
              : "685px"
        }}
        onClick={handleSlideListOnClick ? () => handleSlideListOnClick() : null}
      >
        <div className={styles.slide_content}>
          {!["LAYOUT_0", "THANKING_SLIDE", "QUESTIONS_SLIDE"].includes(
            layout.type
          ) &&
            (!this.context === "embedded" || !embeddedStyle) && (
              <div className={styles.slide_title}>
                <h4>{getLabelsByLng(labels, lng)}</h4>
                {isPresentation ? logoBlock : ""}
              </div>
            )}
          <LayoutFactory
            layoutType={layout.type}
            layoutData={layout}
            componentsBackground={componentsBackground}
            isResponsive={isResponsive}
            isComposition={isComposition}
            inSlideView={inSlideView}
            isPresentation={isPresentation}
            isPreparePresentation={isPreparePresentation}
            handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
            handleRemoveComponent={this.props.removeComponent}
            handleUpdateComponent={this.props.updateComponent}
            comments={comments}
            slideId={id}
            explanations={explanations}
            selectedComponent={this.props.selectedComponent}
            indicators={indicators}
            lng={lng}
            currentOrganization={currentOrganization}
          />
          {id !== 0 && extraInfos ? (
            <span className={styles.slide_info_extra}>
              {extraInfos.lastYear
                ? `${extraInfos.lastYear}-${extraInfos.currentYear}`
                : ""}
              {/*{extraInfos.currentYear}*/}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  composition: state.slideComposition.composition,
  fetchedSlide: state.slideComposition.slide,
  lng: state.params.lng
});

export default connect(mapStateToProps)(Slide);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Slide.js